import React from 'react';
import { Mail, MapPin, ArrowRight } from 'lucide-react';
import { Section } from '../ui/Section';
import { Button } from '../ui/Button';
import { CONTACT } from '../../lib/constants';
const leaders = [{
  initials: 'CC',
  name: CONTACT.ceo,
  role: 'CEO'
}, {
  initials: 'MR',
  name: CONTACT.growthName,
  role: 'Head of Growth',
  email: CONTACT.growthEmail,
  emailHref: CONTACT.growthEmailHref
}];
const cities = ['Perth', 'Melbourne', 'Sydney', 'Brisbane'];
export function Leadership() {
  return <Section className="bg-white" ariaLabel="Leadership and national footprint" data-id="element-349">
      <div className="grid grid-cols-1 items-stretch gap-6 lg:grid-cols-2 lg:gap-8" data-id="element-350">
        {/* Leadership panel — matched card, fills full height */}
        <div className="flex h-full flex-col rounded-panel border border-border bg-surface-2 p-8" data-id="element-351">
          <p className="text-[13px] font-bold uppercase tracking-[0.12em] text-ct-deep" data-id="element-352">
            The people accountable
          </p>
          <div className="mt-6 grid grid-cols-1 gap-5 sm:grid-cols-2" data-id="element-353">
            {leaders.map(l => <div key={l.initials} className="flex flex-col items-start gap-4 rounded-card border border-border bg-white p-5 shadow-sm" data-id="element-354">
                <span className="flex h-14 w-14 items-center justify-center rounded-full bg-navy font-display text-[18px] font-black text-white ring-2 ring-ct-cyan/30" data-id="element-355">
                  {l.initials}
                </span>
                <div data-id="element-356">
                  <p className="font-display text-[17px] font-bold text-navy" data-id="element-357">
                    {l.name}
                  </p>
                  <p className="text-[14px] text-slate" data-id="element-358">{l.role}</p>
                  {l.email && <a href={l.emailHref} className="mt-2 inline-flex items-center gap-1.5 text-[13px] font-semibold text-ct-deep hover:text-ct-cyan" data-id="element-359">
                      <Mail className="h-3.5 w-3.5" aria-hidden data-id="element-360" />
                      {l.email}
                    </a>}
                </div>
              </div>)}
          </div>
          <p className="mt-6 text-[17px] leading-relaxed text-ink" data-id="element-361">
            Talk directly with the people accountable for CT Group’s growth and
            client experience.
          </p>
          <div className="mt-auto pt-6" data-id="element-362">
            <Button as="a" href="#it-review" variant="navy" data-id="element-363">
              Start the conversation
              <ArrowRight className="h-4 w-4 transition-transform group-hover/btn:translate-x-0.5" aria-hidden data-id="element-364" />
            </Button>
          </div>
        </div>

        {/* National footprint — matched card */}
        <div className="flex h-full flex-col rounded-panel border border-border bg-surface-2 p-8" data-id="element-365">
          <p className="text-[13px] font-bold uppercase tracking-[0.12em] text-ct-deep" data-id="element-366">
            Where we support firms
          </p>
          <h3 className="mt-4 font-display text-[22px] font-bold text-navy" data-id="element-367">
            National footprint
          </h3>
          <div className="mt-6 grid grid-cols-2 gap-3" data-id="element-368">
            {cities.map(c => <span key={c} className="flex items-center gap-2 rounded-xl border border-border bg-white px-4 py-3.5 text-[15px] font-semibold text-ink shadow-sm" data-id="element-369">
                <MapPin className="h-4 w-4 text-ct-cyan" aria-hidden data-id="element-370" />
                {c}
              </span>)}
          </div>
          <p className="mt-auto pt-6 text-[15px] leading-relaxed text-slate" data-id="element-371">
            Established in Perth and supporting professional firms across
            Australia, with a growing east-coast presence.
          </p>
        </div>
      </div>
    </Section>;
}